const initialState = () => ({
  galeryQuery: {
    type: 'sprints',
    sprint: null,
    withoutPhotos: true,
    locationsIds: [],
    startDate: null,
    endDate: null,
    roleId: null,
    usersIds: []
  },
  currentSprint: null,
  currentSprintInfo: {
    type: null,
    locations: [],
    users: [],
    tasks: [],
    photos: []
  },
  currentFormInfo: {
    locations: [],
    formGroups: []
  },
  imagesSprint: [],
  recentForms: [],
  currentForm: null,
  imagesForm: []
})

export default initialState
